import http from 'services/http';
import { generateUrl } from 'utils/url';
import ENDPOINTS from 'constants/endpoints';


export const getParentByLocation = async ({ lat, lng }) => {
  const {
    data: { data },
  } = await http.get(
    generateUrl({
      url: ENDPOINTS.GET_ALL_PARENTS_BY_LOCATION,
      query: { lat, lng },
    }),
  );
  return data;
};

export const getParentsByOrganization = () => http.get(
  'v1/organization/{{organizationId}}/parents/',
).then((res) => res.data);
